/**
 * RTK Query API режима технических работ: позволяет web читать и переключать
 * общую «шторку», а также отображать подтверждённые статусы worker pod'ов.
 * DEVELOPMENT-446: https://tracker.yandex.ru/DEVELOPMENT-446
 */
import { api } from 'services/api';

export interface MaintenanceState {
  enabled: boolean;
}

export interface MaintenanceWorkerStatus {
  podId: string;
  enabled: boolean;
}

interface MaintenanceWorkersResponse {
  workers: MaintenanceWorkerStatus[];
}

const systemMaintenanceApi = api
  .enhanceEndpoints({ addTagTypes: ['SYSTEM_MAINTENANCE'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getSystemMaintenance: build.query<MaintenanceState, void>({
        query: () => ({
          url: '/system/maintenance',
          method: 'GET'
        }),
        providesTags: ['SYSTEM_MAINTENANCE']
      }),
      updateSystemMaintenance: build.mutation<
        MaintenanceState,
        MaintenanceState
      >({
        query: (state) => ({
          url: '/system/maintenance',
          method: 'PUT',
          data: state
        }),
        invalidatesTags: ['SYSTEM_MAINTENANCE']
      }),
      getSystemMaintenanceWorkers: build.query<
        MaintenanceWorkersResponse,
        void
      >({
        query: () => ({
          url: '/system/maintenance/workers',
          method: 'GET'
        })
      })
    })
  });

export const {
  useGetSystemMaintenanceQuery,
  useUpdateSystemMaintenanceMutation,
  useGetSystemMaintenanceWorkersQuery
} = systemMaintenanceApi;
